export default __webpack_public_path__ + "26ecffcced0eb95c1b6ea53663a8d432.png";